import React from 'react'
import useAuth from '../../hooks/useAuth'
import BhanzuBot from './BhanzuBot'

/**
 * BhanzuBot for a signed-in user only: nothing on the sign-in screen (the
 * assistant's routes need the admin cookie, and AuthChecker sends anyone
 * signed out there).
 */
const SignedInBhanzuBot = () => {
    const { user } = useAuth()
    return user?.email ? <BhanzuBot /> : null
}

export { BhanzuBot }
export default SignedInBhanzuBot
